// S ::::: 셔플댄스 지도자 자격증 ::::: S
export const qualificationsLists = [
  {
    title: "셔플댄스 지도자 자격증 2급",
    texts: ["9주 교육과정", "교육과정 이수 후 자격검정 응시"],
    targets: [
      "Ipdia 본부센터 또는 지부 강사진 수업 40회 이상 수강자 우선 선발",
      "타 댄스 자격증 소지자 또는 댄스관련 직업인",
      "셔플댄스 1년 이상 경력",
      "서류 심사 후 합격자는 교육과정 합류가능",
    ],
    curriculums: [
      "셔플댄스 강의 시 필요한 역량 트레이닝",
      "프로댄서를 목표로 하는 실전 중심 교육",
      "셔플댄스 주요 스텝 교정 및 심화 트레이닝",
      "댄스에 대한 필수 소양 및 이해",
      "강의법 교육 및 훈련",
      "IPDIA 자격 취득자 교육 워크샵 참여권한 부여",
    ],
    goals: [
      "셔플댄스 지도자 강의 자격 부여",
      "전문적인 댄스 지식 및 실력 향상",
      "연령제한 없는 지도자 양성",
    ],
  },
  {
    title: "셔플댄스 지도자 자격증 1급",
    texts: ["9주 교육과정", "교육과정 이수 후 자격검정 응시"],
    targets: [
      "IPDIA 셔플댄스 지도자 자격증 2급 취득자",
      "서울본부센터 마스터 단계 1년이상 수강자",
    ],
    curriculums: [
      "셔플댄스 강의 시 필요한 고난도 역량 트레이닝",
      "전문 댄서 레벨의 실전 중심 교육",
      "셔플댄스 응용 스텝 및 풋워크 심화 트레이닝",
      "강의법 교육 및 훈련",
      "IPDIA 자격 취득자 교육 워크샵 참여권한 부여",
    ],
    goals: [
      "셔플댄스 지도자 강의 자격 부여",
      "프로급의 댄스 지식 및 실력 향상",
      "연령제한 없는 지도자 양성",
    ],
  },
];
// E ::::: 셔플댄스 지도자 자격증 ::::: E
